import { render, staticRenderFns } from "./BImageForm.vue?vue&type=template&id=572906be&"
import script from "./BImageForm.vue?vue&type=script&lang=js&"
export * from "./BImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports